import React from "react";
import { Wrapper } from "./LeadSubmission.styled";
import { Button, Row, Col, Input, Form } from "components/common";

const LeadSubmission = ({ next, setFormData, formData, isSmall }) => {
    const onFinish = (values) => {
        setFormData({
            ...formData,
            firstName: values?.firstName,
            lastName: values?.lastName,
            email: values?.email,
            phone: values?.phone,
            street: values?.street,
            city: values?.city,
            state: values?.state,
            zip: values?.zip,
        });
        next();
    };

    return (
        <Wrapper isSmall={isSmall}>
            <div className="lead-submission-container">
                <Form name="basic" initialValues={formData} onFinish={onFinish} autoComplete="off">
                    {isSmall ? (<div className="sm-heading-container">
                        <span className="heading-big">NEW CUSTOMER SUBMISSION</span>
                        <span className="heading-small">Input Homeowner Information</span>
                    </div>) : (<div className="heading-container">
                        <h2>NEW CUSTOMER SUBMISSION</h2>
                        <h5>Input Homeowner Information</h5>
                    </div>)}
                    <div className="form-container">
                        <Row gutter={[10, 10]}>
                            <Col span={24}>
                                <Form.Item name="firstName" rules={[{ required: true, message: "Please Enter this Field!" }]}>
                                    <Input className="input" placeholder="First Name"  />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item name="lastName" rules={[{ required: true, message: "Please Enter this Field!" }]}>
                                    <Input className="input" type="text" placeholder="Last Name" />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item name="phone" rules={[{ required: true, message: "Please Enter this Field!" }]}>
                                    <Input className="input" type="tel" placeholder="Phone" />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item name="email" rules={[{ required: true, message: "Please Enter this Field!" }]}>
                                    <Input className="input" type="email" placeholder="Email" />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item name="street" rules={[{ required: true, message: "Please Enter this Field!" }]}>
                                    <Input className="input" type="text" placeholder="Street Address" />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item name="city" rules={[{ required: true, message: "Please Enter this Field!" }]}>
                                    <Input className="input" type="text" placeholder="City" />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item name="state" rules={[{ required: true, message: "Please Enter this Field!" }]}>
                                    <Input className="input" type="text" placeholder="State" />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item name="zip" rules={[{ required: true, message: "Please Enter this Field!" }]}>
                                    <Input className="input" type="text" placeholder="Zip Code"/>
                                </Form.Item>
                            </Col>
                        </Row>
                    </div>
                    <Form.Item>
                        <div className="page-change-button">
                            <Button  className='test' title="Next" htmlType="submit" />
                        </div>
                    </Form.Item>
                </Form>
            </div>
        </Wrapper>
    );
};

export default LeadSubmission;
